export const EMPTY_GEOJSON = { type: "FeatureCollection", features: [] };
